import React from 'react';
import { motion } from 'framer-motion';
import { RadioIcon } from 'lucide-react';
export function CTA() {
  return <section className="py-24 relative z-10 bg-studio-900 overflow-hidden" data-id="element-11">
      <div className="absolute inset-0 bg-stream-600/5" data-id="element-12" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-stream-600/20 rounded-full blur-[100px] pointer-events-none" data-id="element-13" />

      <div className="max-w-4xl mx-auto px-6 relative text-center" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="glass-panel monitor-frame p-12 rounded-2xl border-stream-500/30" data-id="element-15">
          <div className="w-16 h-16 mx-auto bg-stream-500/20 rounded-full flex items-center justify-center mb-6" data-id="element-16">
            <RadioIcon className="w-8 h-8 text-stream-400 animate-pulse" data-id="element-17" />
          </div>

          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-18">
            Ready to Go Live?
          </h2>
          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-19">
            No contracts. No fluff. Just a clear plan to grow your channel and
            multiply your revenue.
          </p>

          <button className="px-8 py-4 bg-stream-600 hover:bg-stream-500 text-white text-lg font-bold rounded-lg transition-all shadow-[0_0_25px_rgba(168,85,247,0.5)] hover:shadow-[0_0_35px_rgba(168,85,247,0.7)] hover:-translate-y-1" data-id="element-20">
            Book Your Free Channel Assessment
          </button>
        </motion.div>
      </div>
    </section>;
}